/**
 * mbar-live(2026-11-04 · Node 「관심고객 등록 버튼 위에 떠 있는 LIVE 배지 — 이 현장 누적 조회수」 F-4안).
 * 순수 함수(서버·클라이언트 공용 · 훅·DB 없음). 숫자 가공·바닥값·부풀림 0 — 값이 없으면 null(화면은 숨김).
 *
 *   · 원천 = apt_sites.page_views(/api/apt/view → increment_site_view 가 올리는 누적 카운터). 서버 HTML 에 바로 박는다
 *     (봇·방문자 무관 같은 값 · 레이아웃 시프트 0). 수화 뒤 /api/visitors/site?slug= 로 올라간 값만 받아 1초 굴림.
 *   · 헤더 카운터(lib/nav/visitor-count)와 같은 표기 규칙(천 단위 쉼표 · 서버/브라우저 동일 글자).
 */
import { formatCount } from '@/lib/nav/visitor-count';

export const SITE_VIEWS_API = '/api/visitors/site';
/** 폴링 — 탭이 보일 때만 60초(헤더의 느린 주기와 같다). 바가 한 페이지에 하나뿐이라 빠른 창은 두지 않는다. */
export const SITE_VIEWS_POLL_MS = 60_000;
/** 응답 CDN 캐시 — 30초 신선 · 30초 낡은 값 허용. 상세 1쪽당 1요청/분 → 현장 1곳당 분당 최대 2회. */
export const SITE_VIEWS_CACHE_CONTROL = 'public, s-maxage=30, stale-while-revalidate=30';
export const SITE_VIEWS_FAIL_CACHE_CONTROL = 'public, s-maxage=10';

/** 누적 조회수 정규화 — 숫자·숫자 문자열만, 음수·NaN 은 null. 0 은 0(표시는 호출부가 숨긴다). */
export function parseSiteViews(v: unknown): number | null {
  const n = typeof v === 'number' ? v : typeof v === 'string' && v.trim() !== '' ? Number(v) : Number.NaN;
  return Number.isFinite(n) && n >= 0 ? Math.floor(n) : null;
}

/** API 응답({ ok, views }) → 숫자. ok=false·모양 다름 → null. */
export function parseSiteViewsResponse(j: unknown): number | null {
  if (!j || typeof j !== 'object') return null;
  const r = j as Record<string, unknown>;
  if (r.ok !== true) return null;
  return parseSiteViews(r.views);
}

/** 배지에 보이는 문구 — 「이 현장 조회 2,431회」. 0 이하·null 이면 null(배지 자체를 그리지 않는다). */
export function siteViewsLabel(views: number | null): string | null {
  if (views == null || views <= 0) return null;
  return `이 현장 조회 ${formatCount(views)}회`;
}

/** 스크린리더용 — 버튼 aria-describedby 로 읽힌다(「LIVE」 표지는 aria-hidden). */
export function siteViewsAria(views: number | null): string | null {
  const l = siteViewsLabel(views);
  return l ? `${l} (실시간 갱신)` : null;
}
